import { startConversation } from "../services/leads.api"

export function GenericInfoField({ id, spanSize, label, value, size = 43 }) {

  const handleStartConversation = async (leadId: string) => {
    const result = await startConversation(leadId)
    if (result.ok) {
      window.open(result.data, "_blank")
    }
  }

  return (
    <>
      <div key={id} className={`${spanSize} gap-3`}>
        <label className="font-semibold text-sm">{label}:</label>
        {label.includes('WhatsApp') ? (
          <p className="border border-gray h-[43px]  text-gray2 mb-3 p-2 overflow-hidden rounded w-full bg-[#ffffff]">
            <a
              onClick={() => handleStartConversation(id || "")}
              target="_blank"
              rel="noopener noreferrer"
              className="text-bluePrimary underline cursor-pointer"
            >
              {value}
            </a>
          </p>
        ) : (
          <p className={`border border-gray h-[${size}px] text-gray2 mb-3 p-2 overflow-hidden rounded w-full bg-[#ffffff]`}>{value}</p>
        )}
      </div>
    </>
  )
}